let msConfig = {
  appId: 'f83cf107-2cf5-4d89-b6cf-40125205b570',
  redirectUri: 'https://app.boltinsight.com/login',
  postLogoutRedirectUri: 'https://app.boltinsight.com/login',
  scopes: ['user.read'],
  authority: 'https://login.microsoftonline.com/boltinsight.com',
};

if (process.env.REACT_APP_ENV === 'dev') {
  // DEV ENVIRONMENT

  msConfig.appId = 'e02afa27-0fb3-40b7-bc45-710568a95f6a';
  msConfig.redirectUri = 'https://app-dev.boltinsight.com/login';
  msConfig.postLogoutRedirectUri = 'https://app-dev.boltinsight.com/login';
}

if (process.env.NODE_ENV === 'development') {
  if (process.env.REACT_APP_ENV === 'local') {
    msConfig.appId = 'b71a58ef-becc-47c2-a09a-4dcc818065c5';
    msConfig.redirectUri = 'http://localhost:3002/login';
    msConfig.postLogoutRedirectUri = 'http://localhost:3002/login';
  } else {
    msConfig.appId = 'e02afa27-0fb3-40b7-bc45-710568a95f6a';
    msConfig.redirectUri = 'https://app-dev.boltinsight.com/login';
    msConfig.postLogoutRedirectUri = 'https://app-dev.boltinsight.com/login';
  }
}
//
export { msConfig };
